import { Box, Button, Heading, Image, Skeleton } from "@chakra-ui/react";
import React from "react";
import { Link } from "react-router-dom";
import defaultLogo from "../../assets/logo.png";

const C = {
  primary: "#E85D04",
  secondary: "#9A3412",
  border: "#E8E0D5",
  cream: "#FFF7ED",
  paper: "#FFFFFF",
  mutedBg: "#F5F0E8",
};

const BASE_URL = "https://asquera.com/asquera";

function sectionImageUrl(section) {
  const path = section?.image || section?.logo;
  if (!path || path === "null" || path === "undefined" || path === "NULL") {
    return defaultLogo;
  }
  if (String(path).startsWith("http")) return path;
  return `${BASE_URL}/${String(path).replace(/^\//, "")}`;
}

const SectionCard = ({ section, to, ctaLabel = "Continue Learning" }) => {
  const img = sectionImageUrl(section);
  const isDefaultLogo = img === defaultLogo;

  return (
    <Box
      w="260px"
      maxW="100%"
      bg={C.paper}
      borderWidth="1px"
      borderColor={C.border}
      borderRadius="xl"
      overflow="hidden"
      display="flex"
      flexDirection="column"
      transition="transform 220ms ease, box-shadow 220ms ease, border-color 220ms ease"
      willChange="transform"
      _hover={{
        borderColor: C.primary,
        transform: "scale(1.02)",
        boxShadow: "0 18px 46px rgba(232, 93, 4, 0.22), 0 0 0 1px rgba(232, 224, 213, 0.45)",
      }}
      _active={{ transform: "scale(1.01)" }}
    >
      <Box
        position="relative"
        h="180px"
        w="100%"
        overflow="hidden"
        bg="gray.100"
        flexShrink={0}
      >
        <Image
          src={img}
          alt={section.name || "Section"}
          position="absolute"
          inset={0}
          w="100%"
          h="100%"
          objectFit={isDefaultLogo ? "contain" : "cover"}
          objectPosition="center"
          display="block"
          bg={isDefaultLogo ? C.mutedBg : "gray.100"}
          p={isDefaultLogo ? 6 : 0}
          fallback={<Skeleton position="absolute" inset={0} h="full" w="full" />}
        />
      </Box>
      <Box p={4} flex={1} display="flex" flexDirection="column">
        <Heading
          as="h3"
          fontSize="md"
          fontWeight="800"
          color={C.primary}
          mb={3}
          lineHeight="1.3"
          noOfLines={2}
          textAlign="center"
        >
          {section.name}
        </Heading>

        <Box mt="auto">
          <Button
            as={Link}
            to={to}
            w="full"
            py={3}
            size="sm"
            fontSize="sm"
            borderWidth="2px"
            borderColor={C.primary}
            color={C.primary}
            fontWeight="800"
            borderRadius="lg"
            variant="outline"
            _hover={{ bg: C.secondary, color: C.cream, borderColor: C.secondary }}
          >
            {ctaLabel}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default SectionCard;
